export default __webpack_public_path__ + "static/media/footerLogo.01a5a00b.png";